<h2 class="title">{{ '+VOUCHERS.SIMULATE_BOOKING' | translate }}</h2>
<vi-text class="description">{{ '+VOUCHERS.SIMULATE_BOOKING_DESCRIPTION' | translate }}</vi-text>
<div class="grid">
  <!-- BOILER SERIAL INPUT-->
  <mat-form-field mat-input-height-large-label class="boiler-serial-input">
    <mat-label>{{ '+VOUCHERS.BOILER_SERIAL' | translate }}</mat-label>
    <input
      gtm="onEditTextField"
      [gtmOn]="['change']"
      gtmAction="Boiler serial"
      gtmCategory="voucher"
      (focus)="gtmService.track('onFocusTextField', 'Boiler serial', 'voucher')"
      (blur)="gtmService.track('onBlurTextField', 'Boiler serial', 'voucher')"
      matInput
      [formControl]="formGroup.controls.boilerSerial"
      fieldTextContentTooltip
    />
  </mat-form-field>

  <!-- CUSTOMER NUMBER INPUT -->
  <mat-form-field mat-input-height-large-label class="company-number-input">
    <mat-label>{{ '+VOUCHERS.CUSTOMER_NUMBER' | translate }}</mat-label>
    <input
      gtm="onEditTextField"
      [gtmOn]="['change']"
      gtmAction="Customer number"
      gtmCategory="voucher"
      (focus)="gtmService.track('onFocusTextField', 'Customer number', 'voucher')"
      (blur)="gtmService.track('onBlurTextField', 'Customer number', 'voucher')"
      matInput
      [formControl]="formGroup.controls.companyId"
      fieldTextContentTooltip
    />
  </mat-form-field>

  <!-- SIMULATE BTN -->
  <button
    disabled
    gtm="onSelect"
    gtmAction="Simulate Subscription"
    gtmCategory="voucher"
    mat-raised-button
    color="primary"
    (click)="simulateSubscription()"
    [disabled]="!formGroup.valid || (bookingStore.isSimulatingSubscription$ | async)"
  >
    <ng-container *ngIf="!(bookingStore.isSimulatingSubscription$ | async); else loading">{{
      '+VOUCHERS.SIMULATE_BTN' | translate
    }}</ng-container>
    <ng-template #loading><mat-icon class="spin">autorenew</mat-icon></ng-template>
  </button>
</div>

<ng-container *ngIf="isSimulationTriggered">
  <app-voucher-result-box
    *ngIf="bookingStore.subscriptionSimulatedSuccesfully$ | async"
    [success]="true"
  >
    <span content>
      {{ '+VOUCHERS.BOOKING_SIMULATION_SUCCESS' | translate }}
    </span>
  </app-voucher-result-box>

  <app-voucher-result-box *ngIf="errorKey" [success]="false">
    <ng-container content>
      {{ errorKey | translate }}
      <p *ngIf="errorDetails">
        {{ errorDetails }}
      </p>
    </ng-container>
  </app-voucher-result-box>
</ng-container>
